import _ from "lodash";
import React from "react";
import moment from "moment";
import classNames from "classnames";

import { getTimeSince, getCommentDisplayContent } from "Utils";
import Unveil from "UIComponents/Unveil";
import ChatbarWrapper from "UIComponents/ChatbarWrapper";
import { AttachmentList } from "Attachment";
import {
  Dropdown,
  IconButton,
  DropdownMenu,
  Avatar,
  Tooltip,
} from "@toddle-edu/ds-web";
import { DotsVerticalOutlined } from "@toddle-edu/ds-icons";
import { useI18n } from "Hooks";

import classes from "./CommentItemV2.scss";
import { getFormattedUserName } from "Utils/GetFormattedUserName";

const MENU_ITEMS = t => [
  {
    label: t("edit"),
    key: "EDIT",
  },
  {
    label: t("delete"),
    key: "DELETE",
    isDestructive: true,
  },
];

const CommentItemV2 = props => {
  const {
    commentData,
    isRightPaneChat,
    userId,
    handleClickDelete,
    canCreateAudioComment,
    disableTagging,
    collaborators,
    placeholder,
    parentType,
    mode,
    handleClickEdit,
    editCommentId,
    editComment,
    getCommentItemRef,
    chatBarScrollParent,
    testId,
  } = props;
  const { t } = useI18n(["common"]);

  const {
    id: commentId,
    item: { attachments },
    createdAt,
    createdBy: { id, profileImage },
    label,
  } = commentData;

  const menuItems = userId === id ? MENU_ITEMS(t) : [];

  const onMenuItemClick = action => {
    switch (action.key) {
      case "EDIT":
        handleClickEdit({ commentId });
        break;

      case "DELETE":
        handleClickDelete({ commentId });
        break;

      default:
        break;
    }
  };
  const isEditComment = editCommentId === commentId;

  const cancelEditComment = () => {
    handleClickEdit({ commentId: null });
  };

  const onUpdateComment = params => {
    cancelEditComment();
    editComment(params);
  };

  const gridTemplateColumns = isRightPaneChat
    ? "repeat(1,1fr)"
    : _.get(attachments, "length", 0) > 1
    ? "repeat(auto-fill, minmax(92px, 1fr))"
    : "repeat(1,1fr)";

  const { createdBy } = commentData;
  const name = getFormattedUserName({
    user: createdBy,
  });

  return (
    <div className={classes.container} ref={ref => getCommentItemRef(ref)}>
      <div className={classes.upperContainer}>
        <div className={classes.leftContainer}>
          <Avatar name={name} src={profileImage} id={id} theme="light" />
          <Tooltip tooltip={name}>
            <div
              className={classNames("text-label truncate", classes.name)}
              dir="auto"
            >
              {name}
            </div>
          </Tooltip>
          <div className={classNames("text-body-s", classes.textSecondary)}>
            {getTimeSince(moment(createdAt), t)}
          </div>
        </div>
        {mode === "edit" ? (
          _.size(menuItems) > 0 && !isEditComment ? (
            <Dropdown
              disabled={_.includes(commentId, "NEW")}
              overlay={
                <DropdownMenu
                  options={menuItems}
                  onClick={onMenuItemClick}
                  testId={`${testId}-${commentId}-actionMenu`}
                />
              }
              placement="bottomRight"
            >
              <IconButton
                type="plain"
                variant="neutral"
                icon={<DotsVerticalOutlined />}
                testId={`${testId}-${commentId}-actionMenu`}
              />
            </Dropdown>
          ) : null
        ) : null}
      </div>
      <div className={classes.bottomContainer}>
        {isEditComment ? (
          <ChatbarWrapper
            messageData={{
              id: commentId,
              label,
              attachments,
            }}
            sendMessage={onUpdateComment}
            isTaggingEnabled={!disableTagging}
            collaborators={collaborators}
            parentType={parentType}
            inputTextPlaceHolder={placeholder}
            showAddButton={false}
            isAudioRecordingEnabled={canCreateAudioComment}
            cancelEditMessage={cancelEditComment}
            mode={mode}
            shouldExecuteMessageDataUseEffect={false}
            chatBarScrollParent={chatBarScrollParent}
            testIdPrefix={`${testId}-${commentId}`}
          />
        ) : (
          <div>
            <div className={classes.textAttachmentsWrapper}>
              <Unveil maxHeight={104} showCollapse={true}>
                <div
                  className={classNames(classes.textContainer, "text-body")}
                  dangerouslySetInnerHTML={{
                    __html: getCommentDisplayContent(label),
                  }}
                />
              </Unveil>
              <AttachmentList
                value={attachments}
                mode={"view"}
                cardStyle={{ height: 80 }}
                attachmentContainerStyle={{
                  gridTemplateColumns,
                  gridGap: "12px",
                  marginTop: "4px",
                  position: "relative",
                }}
                clubbingCards={2}
                showSingleCardTheme={true}
                isRightPaneChat={isRightPaneChat}
                dsVersion="2.0"
                showWaveformPlayer={true}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CommentItemV2;
